export type CancelablePromise<T> = Promise<T> & {
  cancel: () => void;
};
export const makeCancelable = <T>(
  promise: Promise<T>
): CancelablePromise<T> => {
  let isCanceled = false;
  let rejectHandler;

  const wrappedPromise: CancelablePromise<T> = new Promise<T>(
    (resolve, reject) => {
      rejectHandler = reject;
      /* not call resolve or reject if wrapped promise was cancel */
      promise
        .then(val => !isCanceled && resolve(val))
        .catch(err => !isCanceled && reject(err));
    }
  ) as CancelablePromise<T>;

  wrappedPromise.cancel = (): void => {
    isCanceled = true;
    rejectHandler(new Error());
  };

  return wrappedPromise;
};
